import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect
} from 'react'
import { AlertColor } from '@mui/material/Alert'
import { toastService } from './service'
import Snackbar from 'components/admin/snackbar'
import { getExceptionMessage } from 'common/utils/exceptions'

interface ToastContextProps {
  showToast: (
    message: any,
    severity?: AlertColor,
    isException?: boolean
  ) => void
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined)

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<{
    message: any
    open: boolean
    severity: AlertColor
    isException: boolean
  }>({
    message: '',
    open: false,
    severity: 'info',
    isException: false
  })

  const showToast = (
    message: any,
    severity: AlertColor = 'info',
    isException: boolean = false
  ) => {
    setToast({ message, open: true, severity, isException })
  }

  const handleClose = () => {
    setToast((prev) => ({ ...prev, open: false }))
  }

  useEffect(() => {
    toastService.registerToast(showToast)
  }, [])

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar
        open={toast.open}
        message={
          toast.isException ? getExceptionMessage(toast.message) : toast.message
        }
        severity={toast.severity}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  )
}

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useSnackbar fora do contexto SnackbarProvider')
  }
  return context
}
